import { useFormatMessage } from 'common/hooks/useFormatMessage';

import { useProductFamiliesQuery } from './query';

export const useProductFamiliesFilterTagText = (productFamilyIds: string[]) => {
  const f = useFormatMessage();
  const { data: productFamilies } = useProductFamiliesQuery(Boolean(productFamilyIds.length));

  return productFamilyIds.map((id, index) => {
    if (index === 0) {
      const productFamily = productFamilies?.find((productFamily) => productFamily.id === id);
      return productFamily?.name ?? `<${f('common.unknown')}>`;
    }

    return id;
  });
};
